// React
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// FutureLab
import { ChatListItemImage } from './chatList/ChatListItemImage';
import { ChatListItemNameAndTime } from './chatList/ChatListItemNameAndTime';
import { ChatListItemUnreadCount } from './chatList/ChatListItemUnreadCount';

// Reducer
import { RootState } from '../../reducers';
import { chatItemInFocus } from '../../actions/chatItemInFocusActions';
import { useAppDispatch } from '../../store/hooks';

export interface ChatListDataInterface {
	id: number;
	_id?: number;
	isGroupChat: boolean;
	latestAttachment?: string[];
	latestMessage?: unknown;
	latestMessageDateTime?: string;
	chatAdmins?: ChatParticipantsInterface[];
	name: string;
	unreadCount?: number;
	participants: ChatParticipantsInterface[];
	pendingApprovalParticipants: ChatParticipantsInterface[];
	createdAt?: Date;
}

export interface ChatListItemsInterface {
	chatListItem: ChatListDataInterface;
	chatListParticipants?: any[];
	targetRef: any;
	showMessagePreview?: boolean;
}

export interface ChatParticipantsInterface {
	_id: number;
	userId: number;
	isAdmin: boolean;
}

export function ChatListItemsDesktop({ chatListItem, targetRef, showMessagePreview = true }: ChatListItemsInterface) {
	const userListProfilesDetails = useSelector((state: RootState) => state.userListProfilesDetails);
	const loggedInUserDetails = useSelector((state: RootState) => state.loggedInUserDetails);
	const chatInFocus = useSelector((state: RootState) => state.chatInFocus);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const scrollToChatListInFocus = useRef<HTMLDivElement>(null);

	useEffect(() => {
		chatInFocus?.id === chatListItem?.id
			? scrollToChatListInFocus.current?.scrollIntoView({ behavior: 'smooth' })
			: '';
	}, []);

	const selectChat = () => {
		dispatch(chatItemInFocus(chatListItem));

		if (!window.matchMedia('(min-width: 992px)').matches) {
			navigate('../chat/chat-room');
		}
	};

	return (
		<div
			ref={scrollToChatListInFocus}
			className={
				chatInFocus?.id === chatListItem?.id
					? 'border-b border-slate-200 bg-primary/10'
					: 'border-b border-slate-200 bg-white'
			}
		>
			<button
				aria-label={`Open chat with ${chatListItem.name || 'participant'}`}
				className="grid min-h-20 w-full min-w-0 grid-cols-[3.25rem_minmax(0,1fr)] items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary"
				onClick={selectChat}
				ref={targetRef}
				type="button"
			>
					<ChatListItemImage
						chatListItem={chatListItem}
						loggedInUserDetails={loggedInUserDetails}
						userListProfilesDetails={userListProfilesDetails}
					/>
					<div className="min-w-0 self-center">
					<ChatListItemNameAndTime
						chatListItem={chatListItem}
						loggedInUserDetails={loggedInUserDetails}
						userListProfilesDetails={userListProfilesDetails}
						showTime={showMessagePreview}
					/>
						{showMessagePreview && <ChatListItemUnreadCount chatListItem={chatListItem} />}
					</div>
				</button>
		</div>
	);
}
